@if (selectedMode?.length > 0) {
  <h4 class="mt-0">{{ 'Ausgewählte' | mrTranslate | titlecase }} {{ 'Statistik' | mrTranslate }}:</h4>
  <p class="mt-0">
    @for (sel of selectedMode; track sel; let i = $index) {
      <span>
        {{
          (sel.column ? sel.name
          : sel.bezeichnung ? sel.bezeichnung
          : sel
          )
            | titlecase
            | mrTranslate
        }}
        @if (i !== selectedMode.length - 1) {
          <cds-icon shape="angle" direction="right" style="color: #bbbbbb" />
        }
      </span>
    }
  </p>
  <div id="statisticWrapper" #statisticWrapper>
    @if (!isLoading && !isEmpty && currentstatistic.length > 0 && !isTable) {
      <app-plotly-plot
        [className]=""
        [data]="currentstatistic"
        [layout]="graph.layout"
        [config]="graph.config"></app-plotly-plot>
    }
    @if (!isLoading && !isEmpty && isTable && currentstatistic; as table) {
      <clr-datagrid id="datagridWrapper" class="datagrid-compact">
        @for (col of table.columns; track col) {
          <clr-dg-column [clrDgField]="col.id">
            {{ col.id | titlecase | mrTranslate }}
          </clr-dg-column>
        }
        <clr-dg-row *clrDgItems="let row of table.rows">
          @for (col of table.columns; track col) {
            <clr-dg-cell>{{ row[col.id] }}</clr-dg-cell>
          }
        </clr-dg-row>
        <clr-dg-footer>{{ table.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    }
    @if (isLoading) {
      <div class="flexCenterWrapper">
        <clr-spinner>{{ 'Lädt' | mrTranslate }} ...</clr-spinner>
      </div>
    }
    @if (isEmpty && !isLoading) {
      <div class="flexCenterWrapper">
        {{ 'Leeres Ergebnis.' | mrTranslate }}
      </div>
    }
  </div>
} @else {
  <p class="mt-0">
    {{ 'Bitte links eine Statistik auswählen.' | mrTranslate }}
  </p>
}
